import React from 'react'
import Empty from '../feedback/Empty'

function PatientRecords() {
    return (
        <div className='space-y-3'>
            <p className='font-bold text-lg'>Patient Records</p>
            <hr />
            <Empty objectName={"Patient Records"}/>
        </div>
    )
}

export default PatientRecords